import { Appearance } from 'react-native';

import { EThemeScheme } from '@webtrader/core/themes';
import { DARK_THEME_COLORS, LIGHT_THEME_COLORS } from '@webtrader/core/themes/colors';

export const mapNativeScheme = () => {
  return Appearance.getColorScheme() === 'dark' ? EThemeScheme.DARK : EThemeScheme.LIGHT;
};

export const mapNativeSchemeToColors = () => {
  return Appearance.getColorScheme() === 'dark' ? DARK_THEME_COLORS : LIGHT_THEME_COLORS;
};
